import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import { Routes, Route } from "react-router-dom";
import Login from "./components/login";
import RecoverPass from './components/recover-pass';
import UserPage from './components/userPage';
import NotFound from './components/notFound';
import SignUp from './components/signup';
import Admin from './components/admin';
import { ProtectedRoute, AdminRoute } from './components/protectedRoute';
import PartnerApplication from './components/partnerApplication';
import CorporativeRegister from './components/corporativeRegister';
import { AppContextProvider } from './context/contexts';
import { EventsContextProvider } from './context/events';
import { PromosContextProvider } from './context/promos';
import AuthContextProvider from './context/AuthContext';


function App() {

  return (
    <div className="App" id="app">
      <AuthContextProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/recover-pass" element={<RecoverPass />} />
          <Route path="/application" element={<PartnerApplication />} />
          <Route path="/c-application" element={<CorporativeRegister />} />
          <Route
            path="/user"
            element={
              <ProtectedRoute>
                <EventsContextProvider>
                  <PromosContextProvider>
                    <UserPage />
                  </PromosContextProvider>
                </EventsContextProvider>
              </ProtectedRoute>
            }
          />
          <Route path="/admin"
            element={
              <AdminRoute>
                <AppContextProvider>
                  <Admin />
                </AppContextProvider>
              </AdminRoute>}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthContextProvider>
    </div>
  );
}

export default App;